'use client';

import { type Context, createContext, type ReactNode, useContext } from 'react';
import type { Network } from './types';

interface NetworkPresentation {
  readonly network: Network;
  readonly publicSiteOrigin: string;
}
const NetworkPresentationContext: Context<NetworkPresentation | null> =
  createContext<NetworkPresentation | null>(null);

/** Shared presentation follows the SDK host's network without changing public-app preferences. */
export function NetworkPresentationProvider({
  network,
  publicSiteOrigin,
  children,
}: NetworkPresentation & {
  readonly children: ReactNode;
}): ReactNode {
  const parsed = new URL(publicSiteOrigin);
  if (!['http:', 'https:'].includes(parsed.protocol) || parsed.origin !== publicSiteOrigin)
    throw new Error('The public market site must be an HTTP(S) origin.');
  return (
    <NetworkPresentationContext.Provider value={{ network, publicSiteOrigin }}>
      {children}
    </NetworkPresentationContext.Provider>
  );
}
export function useNetworkPresentation(): NetworkPresentation | null {
  return useContext(NetworkPresentationContext);
}
